// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallMemberPermissionsItem__container-e32e60 {
  padding: 8px 24px;
  display: flex;
  align-items: center;
  text-decoration: none;
  width: 100%;
}

.CallMemberPermissionsItem__member-info-e348cd {
  margin-inline-start: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.CallMemberPermissionsItem__member-name-c20bf1 {
  font: var(--font-body-2);
  color: var(--base-110);
  letter-spacing: var(--font-spacing-body-2);
  text-align: left;
}

.CallMemberPermissionsItem__member-permissions-ee709d {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallPermissionsPopup/components/CallMemberPermissionsItem/CallMemberPermissionsItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,sBAAA;EACA,0CAAA;EACA,gBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF","sourcesContent":[".container {\n  padding: 8px 24px;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  width: 100%;\n}\n\n.member-info {\n  margin-inline-start: 12px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.member-name {\n  font: var(--font-body-2);\n  color: var(--base-110);\n  letter-spacing: var(--font-spacing-body-2);\n  text-align: left;\n}\n\n.member-permissions {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CallMemberPermissionsItem__container-e32e60`,
	"member-info": `CallMemberPermissionsItem__member-info-e348cd`,
	"memberInfo": `CallMemberPermissionsItem__member-info-e348cd`,
	"member-name": `CallMemberPermissionsItem__member-name-c20bf1`,
	"memberName": `CallMemberPermissionsItem__member-name-c20bf1`,
	"member-permissions": `CallMemberPermissionsItem__member-permissions-ee709d`,
	"memberPermissions": `CallMemberPermissionsItem__member-permissions-ee709d`
};
module.exports = ___CSS_LOADER_EXPORT___;
